export function analyticsTrackWithSegments(eventName, segments, properties={}, silent=true) {
    properties = {
        ...properties,
        "sfdcSegmentC": segments.segmentC,
        "sfdcOwnerRole": segments.ownerRole,
    }
    try {
        analytics.track(eventName, properties)
    } catch(e) {
        if (!silent) console.error(e)
    }
}

export function analyticsTrack(eventName, properties={}, silent=true) {
    try {
        analytics.track(eventName, properties)
    } catch(e) {
        if (!silent) console.error(e)
    }
}

export function analyticsPage(properties={}, silent=true) {
    try {
        analytics.page(properties);
    } catch(e) {
        if (!silent) console.error(e);
    }
}

export function analyticsIdentify(properties={}, silent=true) {
    try {
        analytics.identify(properties);
    } catch(e) {
        if (!silent) console.error(e);
    }
}

export function analyticsAlias(identifier, properties={}, silent=true) {
    try {
        analytics.alias(identifier, properties);
    } catch(e) {
        if (!silent) console.error(e);
    }
}

export function analyticsUserTraitsIdentified(...traits) {
    try {
        const identified_traits = analytics.user().traits();

        for (let i = 0; i < traits.length; i++) {
            let hasTrait = traits[i] in identified_traits;
            if (!hasTrait) {
                return false;
            }
        }

        return true;
    } catch (e) {
        return false;
    }
}
